import React from "react";
import moment from "moment";

const GOLD = "#ffc000";
const PRIMARY = "#000c66";

const Initials = ({ name }) => {
  const letters = name
    ? name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()
    : "?";
  return (
    <div
      className="shrink-0 flex items-center justify-center rounded-full font-aref font-bold text-sm"
      style={{
        width: 38,
        height: 38,
        background: `${GOLD}22`,
        border: `2px solid ${GOLD}`,
        color: PRIMARY,
      }}
    >
      {letters}
    </div>
  );
};

export const Commenter = ({ name, time, comment }) => (
  <div
    className="flex items-start gap-3 px-4 py-4 rounded-lg"
    style={{ background: "#fff", border: `1px solid ${GOLD}22`, boxShadow: "0 1px 8px rgba(0,0,0,0.04)" }}
  >
    <Initials name={name} />
    <div className="flex flex-col gap-1 min-w-0">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-aref font-bold text-sm" style={{ color: PRIMARY }}>
          {name}
        </span>
        <span className="font-abel text-xs" style={{ color: "#bbb" }}>
          · {moment(time, "Do MMM YYYY, h:mma").isValid()
            ? time
            : moment(time).format("Do MMM YYYY, h:mma")}
        </span>
      </div>
      <p className="font-abel text-sm leading-relaxed" style={{ color: "#555" }}>
        {comment}
      </p>
    </div>
  </div>
);
